// src/components/winback/SegmentBadge.jsx
import React from 'react';

const SegmentBadge = ({ segment }) => {
    const segmentStyles = {
        'Campeones': {
            bg: 'bg-green-100',
            text: 'text-green-800',
            border: 'border-green-300'
        },
        'Clientes Fieles': {
            bg: 'bg-blue-100',
            text: 'text-blue-800',
            border: 'border-blue-300'
        },
        'En Riesgo': {
            bg: 'bg-yellow-100',
            text: 'text-yellow-800',
            border: 'border-yellow-300'
        },
        'No Pueden Perderse': {
            bg: 'bg-orange-100',
            text: 'text-orange-800',
            border: 'border-orange-300'
        },
        'A Punto de Dormir': {
            bg: 'bg-red-100',
            text: 'text-red-800',
            border: 'border-red-300'
        },
        'Perdidos': {
            bg: 'bg-gray-100',
            text: 'text-gray-800',
            border: 'border-gray-300'
        },
        'Sin Compras': {
            bg: 'bg-purple-100',
            text: 'text-purple-800',
            border: 'border-purple-300'
        }
    };

    const style = segmentStyles[segment] || segmentStyles['Sin Compras'];

    return (
        <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border ${style.bg} ${style.text} ${style.border}`}>
            {segment || 'Sin Segmento'}
        </span>
    );
};

export default SegmentBadge;

